var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("DsfFormControlBox", {
    staticClass: "ds-area-select",
    attrs: { owner: _vm._self },
    scopedSlots: _vm._u(
      [
        {
          key: "simple",
          fn: function () {
            return [
              _c(
                "DsfTextProxy",
                _vm._b(
                  {
                    model: {
                      value: _vm.value,
                      callback: function ($$v) {
                        _vm.value = $$v
                      },
                      expression: "value",
                    },
                  },
                  "DsfTextProxy",
                  _vm._self.$props,
                  false
                )
              ),
              _vm._t("error", function () {
                return [
                  _vm.errors.length > 0
                    ? _c("div", { staticClass: "ds-error-text" }, [
                        _vm._v(_vm._s(_vm.errorsMsg)),
                      ])
                    : _vm._e(),
                ]
              }),
            ]
          },
          proxy: true,
        },
        {
          key: "content",
          fn: function () {
            return [
              _vm.readOnly
                ? _c(
                    "div",
                    { staticClass: "ds-form-readonly" },
                    [
                      _c(
                        "DsfTextProxy",
                        _vm._b(
                          {
                            attrs: { "show-label": false },
                            model: {
                              value: _vm.value,
                              callback: function ($$v) {
                                _vm.value = $$v
                              },
                              expression: "value",
                            },
                          },
                          "DsfTextProxy",
                          _vm._self.$props,
                          false
                        )
                      ),
                    ],
                    1
                  )
                : _vm.showCascader
                ? _c("dsf-area-cascader", {
                    staticClass: "ds-area-select-cascader",
                    attrs: {
                      value: _vm.value,
                      placeholder: _vm.placeholder,
                      "super-code": _vm.superCode,
                      range: _vm.range,
                      "show-all-levels": _vm.showAllLevels,
                      "check-strictly": _vm.checkStrictly,
                      "post-has-alias": _vm.postHasAlias,
                      "options-text-field": _vm.optionsTextField,
                      "selected-text-field": _vm.selectedTextField,
                      disabled: _vm.disabled,
                      readonly: _vm.readOnly,
                    },
                    on: { input: _vm.inputValue },
                  })
                : _vm._e(),
              _vm._t("error", function () {
                return [
                  _vm.errors.length > 0
                    ? _c("div", { staticClass: "ds-error-text" }, [
                        _vm._v(_vm._s(_vm.errorsMsg)),
                      ])
                    : _vm._e(),
                ]
              }),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }